<template>
	<aside class="loader" v-if="loaderVisible">
		<i class="fas fa-cog fa-spin"></i>
	</aside>
</template>

<script>
	import {eventBus} from "../../app";

	export default {
		name: "Loader",
		data () {
			return {
				loaderVisible: false,
			}
		},
		created() {
			let vm = this;
			eventBus.$on('onLoaderStart', function () {
				vm.loaderVisible = true;
			});

			eventBus.$on('onLoaderFinish', function () {
				vm.loaderVisible = false;
			});
		}
	}
</script>
